import { create } from "zustand";

const params = new URLSearchParams(window.location.search);
if (params.has("lite") || params.has("nowebgl")) sessionStorage.setItem("z6_lite", "1");
if (params.has("rich")) sessionStorage.removeItem("z6_lite");

const canWebGL = () => {
  try {
    const c = document.createElement("canvas");
    return !!(window.WebGLRenderingContext && (c.getContext("webgl2") || c.getContext("webgl")));
  } catch {
    return false;
  }
};

export const reducedMotion = () => !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
const lowPower = () => (navigator.deviceMemory && navigator.deviceMemory <= 2) || (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2);
// Low-end tier: few cores, little memory, Android tablets, Save-Data or reduced motion -> static globe, light water, no backdrop blur.
const UA = navigator.userAgent;
const ANDROID_TABLET = /Android/.test(UA) && !/Mobile/.test(UA);
export const LOW = sessionStorage.getItem("z6_lite") === "1" || reducedMotion() || !!navigator.connection?.saveData || ANDROID_TABLET
  || (navigator.hardwareConcurrency || 8) <= 4 || (navigator.deviceMemory || 8) <= 3;
if (LOW) document.documentElement.classList.add("z6-low");

export const RICH = !LOW && canWebGL() && !lowPower();
export const SMALL = window.innerWidth < 640;
export const TOUCH = !!window.matchMedia?.("(pointer: coarse)").matches || navigator.maxTouchPoints > 0;
// iPadOS Safari reports a desktop "Macintosh" UA; touch points tell it apart.
export const IPAD = /iPad/.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
// Tablets get one WebGL context (the globe) at a lower pixel ratio to stay inside the Safari tab memory limit.
export const DPR_CAP = Math.min(window.devicePixelRatio || 1, TOUCH ? 1.5 : 2);
// Rich WebGL water only on strong non-iOS devices; everyone else gets the 2D ripple.
const IOS = /iPhone|iPod|iPad/.test(navigator.userAgent) || IPAD;
const MEM = navigator.deviceMemory;
export const OCEAN_GL = RICH && !IOS && (navigator.hardwareConcurrency || 0) >= 6 && (MEM === undefined ? !TOUCH : MEM >= 4);

export const useAmbient = create((set) => ({
  accent: "#2DD4BF",
  setAccent: (accent) => set({ accent }),
}));

// Read imperatively by the WebGL loop so swipes never trigger React renders.
export const swipe = { active: false, until: 0 };
export const setSwiping = (on) => {
  swipe.active = on;
  if (!on) swipe.until = performance.now() + 250;
};
window.addEventListener("scroll", () => { swipe.until = performance.now() + 220; }, { passive: true, capture: true });
export const isSwiping = () => swipe.active || performance.now() < swipe.until;
